import React from "react";
import orderBy from "lodash/orderBy";
import "./Top3Result.css";

const Top3Result = ({ leaderboard = [], strings = {} }) => {
  const top3 = orderBy(
    leaderboard.filter((p) => p.score > 0),
    "rank",
    "asc"
  ).slice(0, 3);

  if (top3.length === 0) {
    return <div className="no-winners">{strings.noWinners || "No winners yet"}</div>;
  }

  const getDisplayName = (player) => {
    return `${player.firstName || ""} ${player.lastName || ""}`.trim() || player.id;
  };

  const podiumPlaces = [
    { index: 1, className: "second-place", medal: "🥈" },
    { index: 0, className: "first-place", medal: "🥇" },
    { index: 2, className: "third-place", medal: "🥉" },
  ];

  const PodiumItem = ({ player, className, medal }) => (
    <div className={`podium-item ${className}`}>
      <div className="podium-rank">{medal}</div>
      <div className="podium-name">{getDisplayName(player)}</div>
      <div className="podium-score">{player.score} pts</div>
    </div>
  );

  return (
    <div className="top3-container">
      <div className="podium">
        {podiumPlaces.map(
          ({ index, className, medal }) =>
            top3[index] && <PodiumItem key={index} player={top3[index]} className={className} medal={medal} />
        )}
      </div>
    </div>
  );
};

export default Top3Result;
